var config = {
	api_url: 'http://18.212.66.170:3200',
	api_key: 'oJVY0fzvlj9lU3soWqV1cY8cbgv6E6O'
};

module.exports = config;